import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { ProductDescriptionDS } from './product-description-ds'
import { ProductDescriptionLegacy } from './product-description-legacy'

import type { ProductDescriptionProps } from './product-description.types'

const ProductDescription = (props: ProductDescriptionProps) => {
  if (shouldUseDesignSystem()) {
    return <ProductDescriptionDS {...props} />
  }

  return <ProductDescriptionLegacy {...props} />
}

export type { ProductDescriptionProps } from './product-description.types'

export default ProductDescription
